import { datadogRum } from '@datadog/browser-rum';

const DISABLED_MODES = ['local', 'development'];

export const initDatadog = (): void => {
  if (DISABLED_MODES.includes(import.meta.env.MODE)) return;

  const applicationId = import.meta.env.VITE_DD_RUM_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DD_RUM_CLIENT_TOKEN;

  if (!applicationId || !clientToken) return;

  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  const allowedTracingUrls: string[] = [];
  if (apiBaseUrl) {
    try {
      allowedTracingUrls.push(new URL(apiBaseUrl).origin);
    } catch {
      allowedTracingUrls.length = 0;
    }
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: import.meta.env.VITE_DD_SITE,
    service: import.meta.env.VITE_DD_SERVICE,
    env: (import.meta.env.VITE_DD_ENV) || (import.meta.env.VITE_BUGSNAG_RELEASE_STAGE),
    version: import.meta.env.VITE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls,
  });
};
